<div class="detail-title">
  <h1>{{ viewModel?.title }}</h1>
  <div class="line">
    <div class="main-information">
      <div class="wrapper-id">
        <p><span>ID </span> {{ viewModel?.id }}</p>
      </div>
      <div *ngIf="viewModel?.createBy">
        <p><span>Criado por </span> {{ viewModel?.createBy }}</p>
      </div>
      <div class="wrapper-creation-date">
        <p><span>Data de criação </span> {{ viewModel?.creationDate }}</p>
      </div>
      <div *ngIf="viewModel?.entityName">
        <p><span>Comercializadora </span> {{ viewModel?.entityName }}</p>
      </div>
    </div>
    <div class="wrapper-link" *ngIf="viewModel?.actionText">
      <a role="button" tabindex="0" (click)="clickLink()">{{ viewModel?.actionText }}</a>
    </div>
  </div>
</div>
